import { render, staticRenderFns } from "./ProgressInfo.vue?vue&type=template&id=64e53d93&"
import script from "./ProgressInfo.vue?vue&type=script&lang=js&"
export * from "./ProgressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports